
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useProducts } from "@/hooks/useProducts";
import { UseFormReturn } from "react-hook-form";
import { DiscountFormValues } from "@/types/discount";

interface ProductSelectProps {
  form: UseFormReturn<DiscountFormValues>;
  onProductSelect: (value: string) => void;
}

export const ProductSelect = ({ form, onProductSelect }: ProductSelectProps) => {
  const { products } = useProducts();

  return (
    <FormField
      control={form.control}
      name="product_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Product</FormLabel>
          <Select
            onValueChange={(value) => {
              field.onChange(value);
              onProductSelect(value);
              form.setValue("plan_id", "");
            }}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a product" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {products.map((product) => (
                <SelectItem key={product.id} value={product.id}>
                  {product.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
